module.exports = __webpack_public_path__ + "static/media/Darchviz 13.638a0e71.jpg";